import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Tag } from "lucide-react";
import api from "../lib/api";
import ProductCard from "./ProductCard";

/** Home page surplus stock band: the cost-price pitch plus four real items. */
export default function SurplusStockBand() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api
      .get("/products", { params: { limit: 4, sort: "price_desc" } })
      .then((r) => setData(r.data))
      .catch(() => setData({ products: [], total: 0 }));
  }, []);

  const products = data?.products || [];
  if (!products.length) return null;

  return (
    <section
      className="border-y"
      style={{ borderColor: "rgba(198,162,74,0.25)", background: "var(--nq-ink)" }}
      data-testid="home-surplus-band"
    >
      <div className="container-nq section-nq">
        <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
          <div className="max-w-2xl">
            <span
              className="inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-[10px] font-bold uppercase tracking-[0.18em]"
              style={{ background: "var(--nq-gold)", color: "var(--nq-black)" }}
            >
              <Tag className="h-3.5 w-3.5" /> Cost price · no markups
            </span>
            <h2 className="mt-4 text-2xl font-bold leading-tight md:text-4xl">
              {data.total} surplus items, all at{" "}
              <span className="gold-text">what we paid for them</span>
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-[color:var(--nq-stone)] md:text-base">
              Superseded kits, overstock and parts left over from builds - listed at our buy price
              with no margin on top. Card fees, storage and postage come out of our end, so we go
              backwards on most of it. We would rather it went on your 4WD than sat in our shed.
            </p>
          </div>
          <Link
            to="/shop"
            className="btn-gold shrink-0 px-6 py-3"
            data-testid="home-surplus-cta"
          >
            Shop surplus stock <ArrowRight className="h-4 w-4" />
          </Link>
        </div>

        <div className="mt-8 grid grid-cols-2 gap-4 lg:grid-cols-4">
          {products.map((p) => (
            <ProductCard key={p.id} product={p} />
          ))}
        </div>
      </div>
    </section>
  );
}
